import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { Button } from "./ui/button";

const QuoteForm = () => {
  return (
    <section id="contact" className="py-24 lg:py-32 bg-[#f5f5f5]" data-testid="contact-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-sm text-[#525252] tracking-widest mb-4">GET IN TOUCH</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0a0a0a] mb-6">
            CONTACT US
          </h2>
          <p className="text-[#525252] mb-12 leading-relaxed max-w-lg mx-auto">
            Ready to seal your home properly? Get in touch for a free, no-obligation quote.
          </p>
        </motion.div>

        {/* Contact Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4 justify-center mb-16"
        >
          <Button
            asChild
            size="lg"
            className="bg-[#0a0a0a] text-white hover:bg-[#171717] font-heading tracking-wider btn-primary text-base px-8 py-6"
          >
            <a href="tel:0482909501" data-testid="contact-call-btn">
              <Phone className="w-5 h-5 mr-3" />
              CALL 0482 909 501
            </a>
          </Button>
          
          <Button
            asChild
            size="lg"
            variant="outline"
            className="border-[#0a0a0a] text-[#0a0a0a] hover:bg-[#0a0a0a] hover:text-white font-heading tracking-wider text-base px-8 py-6"
          >
            <a href="mailto:hello@ultimatecaulking.co" data-testid="contact-email-btn">
              <Mail className="w-5 h-5 mr-3" />
              EMAIL US
            </a>
          </Button>
        </motion.div>

        {/* Location Info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex items-center justify-center gap-3 text-[#525252]"
        >
          <MapPin className="w-5 h-5" />
          <span className="font-medium">Serving Adelaide & South Australia</span>
        </motion.div>
      </div>
    </section>
  );
};

export default QuoteForm;
